import { isNotFound } from '@agos/api-client'

/**
 * Whether the server said the page is not there - FB-829, §9.544.
 *
 * **Extracted because the inline version was inverted inside the code written to prevent it.**
 * `CmsPagePage`'s comment carries §9.100's rule - *"Only the server saying **404** means missing or unpublished;
 * anything else is this end failing and should say so"* - and the condition read
 * `!(error instanceof ApiError) || error.status === 404`, so **everything that is not an HTTP response counted as
 * missing.**
 *
 * **Reachable by the commonest failure there is, and two ways, both verified in `custom-fetch.ts`:**
 * `customFetch`'s `await fetch(url, …)` is **not** wrapped in a try/catch, so a dropped connection, a DNS failure, a
 * CORS failure or an aborted request rejects with a **`TypeError`**; and `ResponseParseError extends Error` rather
 * than `ApiError`, so a 200 with an unparseable body throws one too. Either way a customer on a phone that lost
 * signal read *stránka ktorú hľadáte neexistuje alebo nie je verejná* about a page that is there.
 *
 * **A named rule rather than a longer condition**, so the predicate is testable and reads as its own documentation -
 * §9.499's `batchNeedsAttention` and §10A.262's `isUnderpayment` are the same shape. And it is **inverted rather than
 * widened**: a variable called `missing` that is true for a network error is how this defect arrives a second time.
 */
export function pageIsMissing(error: unknown): boolean {
  /* §3.162 - **the same question, asked in one place.** The public marketing site renders this concept too
   * and got it wrong in the other direction, so the predicate moved to `@agos/api-client` where `ApiError`
   * lives and both renderers name it. This keeps its own name because it is what the screen and its tests
   * read, and a rename would say the rule had changed when only its home did. */
  return isNotFound(error)
}
